module.exports = __webpack_public_path__ + "static/img/LogoUs.43646562.png";